import request from '@/utils/request'

export function getGeneral(params) {
  return request({
    url: '/siteEss/getGeneral',
    method: 'POST',
    meta: { useAuth: true },
    data: params
  })
}

export function getWorkRecord(params) {
  return request({
    url: '/siteEss/getRecord',
    method: 'POST',
    meta: { useAuth: true },
    data: params
  })
}

export function getWorkErrorRecord(params) {
  return request({
    url: `/siteEss/getErrorRecord`,
    method: 'GET',
    meta: { useAuth: true },
    params
  })
}

export function getWorkTrend(params) {
  return request({
    url: '/siteEss/getTrend',
    method: 'POST',
    meta: { useAuth: true },
    data: params
  })
}
